import React from 'react';
import PropTypes from 'prop-types';

import { BundleCovers } from 'javascripts/components/bundles/bundle_covers';
import { ChirpButton } from 'javascripts/components/chirp_button';

import { ErrorNotifier } from 'javascripts/shared/utils/error_notifier';

import styles from 'stylesheets/components/bundles/bundle_cta';

export function BundleCta({ bundle }) {
  function renderBundleCta() {
    return (
      <div className={styles.ctaWrapper}>
        <ChirpButton
          displayType='button'
          label={`Get Bundle Deal for ${bundle.bundlePrice}`}
          displayStyle='gray'
          fullWidth
        />
      </div>
    );
  }

  function renderPriceSubtitle() {
    return (
      <div className={styles.offerDetails}>
        Get {bundle.tagline} and save {bundle.discountAmount}!
      </div>
    );
  }

  function renderBundleComponent() {
    if (bundle.covers.length > 5) {
      ErrorNotifier.notify(`Too many audiobook covers in bundle ${bundle.id}. Image not rendered for ${bundle.covers.length} covers`);
      return null;
    }

    return (
      <div className={styles.bundleCta} data-testid='generated-bundle-cta' id={`bundle-${bundle.id}`}>
        <h3 className={styles.chirpExclusive}>CHIRP EXCLUSIVE</h3>
        <h3 className={styles.bundleHeader}>BUY THE BUNDLE!</h3>
        {renderPriceSubtitle()}
        <BundleCovers covers={bundle.covers} />
        {renderBundleCta()}
      </div>
    );
  }

  return(renderBundleComponent());
}

BundleCta.propTypes = {
  bundle: PropTypes.shape({
    altText: PropTypes.string,
    clickthroughPath: PropTypes.string,
    tagline: PropTypes.string,
    cloudinaryUrl: PropTypes.string,
    id: PropTypes.string,
    identifier: PropTypes.string,
    bundlePrice: PropTypes.string,
    discountAmount: PropTypes.string,
    covers: PropTypes.arrayOf(
      PropTypes.shape({
        coverUrl: PropTypes.string,
        displayAuthors: PropTypes.string,
        displayTitle: PropTypes.string,
      }),
    ),
  })
};
